/* eslint no-undef: 0 */
import config from '@mediahuis/chameleon-theme-wl/cdn-logos';
const getLogo = function (name, scope, version) {
  if (name === void 0) {
    name = 'brand-main';
  }
  if (scope === void 0) {
    scope = 'main';
  }
  if (version === void 0) {
    version = config.activeVersion;
  }
  if (!config[version] || config[version] && !config[version][scope] || config[version] && config[version][scope] && !config[version][scope][name]) {
    return {
      svg: undefined,
      png: undefined,
      alt: undefined
    };
  }
  return {
    svg: `${config.baseUrl}${version}/${config[version][scope][name].svg}`,
    png: `${config.baseUrl}${version}/${config[version][scope][name].png}`,
    alt: config[version][scope][name].alt || config.alt
  };
};
export default getLogo;